<template>
  <page-header-wrapper>
    <a-card>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" class="table-head-ground">
          <div class="table-layer">
            <a-form-item label="" style="max-width: 520px; min-width:400px">
              <time-range-filter
                ref="timeRangeFilter"
                :default-type="'today'"
                @change="handleTimeRangeChange"
              />
            </a-form-item>
            <a-form-item label="">
              <jeepay-text-up :placeholder="'Order ID'" :msg="searchData.orderNo" v-model="searchData.orderNo" />
            </a-form-item>
<!--            <a-form-item label="">-->
<!--              <jeepay-text-up :placeholder="'应用AppId'" :msg="searchData.appId" v-model="searchData.appId"/>-->
<!--            </a-form-item>-->
<!--            <a-form-item v-if="$access('ENT_PAY_ORDER_SEARCH_PAY_WAY')" label="">-->
<!--              <a-select v-model="searchData.wayCode" placeholder="支付方式" default-value="" style="width: 150px">-->
<!--                <a-select-option value="">全部</a-select-option>-->
<!--                <a-select-option :key="item.wayCode" v-for="item in payWayList" :value="item.wayCode">-->
<!--                  {{ item.wayName }}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
            <a-form-item label="">
              <a-select
                v-model="searchData.state"
                placeholder="支付状态"
                default-value=""
                style="width: 150px"
              >
                <a-select-option
                  v-for="status in PAYMENT_STATUS"
                  :key="status.value"
                  :value="status.value"
                >
                  {{ status.label }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <span class="table-page-search-submitButtons">
              <a-button type="primary" icon="search" @click="queryFunc" :loading="btnLoading">搜索</a-button>
              <a-button style="margin-left: 8px" icon="reload" @click="resetForm">重置</a-button>
              <!-- 导出按钮 -->
              <a-button
                style="margin-left: 8px"
                type="primary"
                icon="export"
                @click="exportFunc"
                :loading="exportLoading"
              >
                导出
              </a-button>
              <!-- 右侧导出记录 -->
              <a-button
                style="margin-left: 8px"
                icon="export"
                @click="showExportRecords"
              >导出记录</a-button>
            </span>
          </div>
        </a-form>
      </div>
      <!-- 统计模块 单独封装成组件，数据请求在这里处理，然后组件只是展示 -->
      <OrderStatistics
        :statisticsData="statisticsData"
        :loading="statisticsLoading"
      />

      <!-- 列表渲染 -->
      <JeepayTable
        @btnLoadClose="handleLoadClose"
        ref="infoTable"
        :initData="true"
        :reqTableDataFunc="reqTableDataFunc"
        :tableColumns="tableColumns"
        :searchData="searchData"
        rowKey="payOrderId"
        :tableRowCrossColor="true"
        :pageSize="100"

      >
        <template
          slot="amountSlot"
          slot-scope="{ record }"
        ><b>{{ formatAmount(record.amount) }}</b></template
        >
        <!-- 自定义插槽 -->
        <template slot="refundAmountSlot" slot-scope="{ record }">{{
          formatAmount(record.refundAmount)
        }}</template>
        <template slot="payTypeSlot" slot-scope="{ record }">
          {{ getPayTypeText(record) }}
        </template>
        <!-- 自定义插槽 -->
        <template slot="stateSlot" slot-scope="{ record }">
          <a-tag
            :key="record.state"
            :color="getPaymentStatusColor(record.state)"
          >
            {{ getPaymentStatusText(record.state) }}
          </a-tag>
        </template>
        <template slot="processStateSlot" slot-scope="{ record }">
          <div style="display: flex; align-items: center;">
            <a-tag
              :key="record.state"
              :color="getPaymentStatusColor(record.state)"
            >
              {{ getPaymentStatusText(record.state) }}
            </a-tag>
          </div>
        </template>
        <template slot="notifySlot" slot-scope="{ record }">
          <a-badge
            :status="record.notifyState === 1 ? 'processing' : 'error'"
            :text="record.notifyState === 1 ? '已发送' : '未发送'"
          />
        </template>
        <template slot="cusNoSlot" slot-scope="{ record }">
          <div class="order-list">
            <p class="order-row">
              <span style="color: #729ed5; background: #e7f5f7">商户</span
              >{{ record.mchNo }}
              <CopyButton :text="record.mchNo" v-if="record.mchNo" />
            </p>
            <p class="order-row">
              <span style="color: #729ed5; background: #e7f5f7">客户</span
              >{{ record.cusNo }}
              <CopyButton :text="record.cusNo" v-if="record.cusNo" />
            </p>
          </div>
        </template>
        <template slot="mchOrderNoSlot" slot-scope="{ record }">
          <div class="order-row" v-if="record.mchOrderNo">
            <a-tooltip
              placement="bottom"
              style="font-weight: normal"
              class="order-content"
            >
              <template slot="title">
                <span>{{ record.mchOrderNo }}</span>
              </template>
              {{
                changeStr2ellipsis(
                  record.mchOrderNo,
                  20
                )
              }}
            </a-tooltip>
            <CopyButton :text="record.mchOrderNo" v-if="record.mchOrderNo" />
          </div>
          <div class="order-row" v-else>
            <span>--</span>
          </div>
        </template>
        <template slot="payOrderIdSlot" slot-scope="{ record }">
          <div class="order-row">
            <a-tooltip
              placement="bottom"
              style="font-weight: normal"
              v-if="record.payOrderId.length > 20"
              class="order-content"
            >
              <template slot="title">
                <span>{{ record.payOrderId }}</span>
              </template>
              {{
                changeStr2ellipsis(
                  record.payOrderId,
                  20
                )
              }}
            </a-tooltip>
            <CopyButton :text="record.payOrderId" v-if="record.payOrderId" />
          </div>
        </template>
        <template slot="orderSlot" slot-scope="{ record }">
          <div class="order-list">
            <p class="order-row">
              <!-- <span class="order-type" style="color: #56cf56; background: #d8eadf">商户</span> -->
              <a-tooltip
                placement="bottom"
                style="font-weight: normal"
                v-if="record.mchOrderNo.length > record.payOrderId.length"
                class="order-content"
              >
                <!-- <template slot="title">
                  <span>{{ record.mchOrderNo }}</span>
                </template> -->
                {{
                  changeStr2ellipsis(
                    record.mchOrderNo,
                    record.payOrderId.length
                  )
                }}
                <CopyButton :text="record.mchOrderNo" v-if="record.mchOrderNo" />
              </a-tooltip>
              <span style="font-weight: normal" v-else>{{
                record.mchOrderNo
              }}</span>
            </p>
          </div>
        </template>
        <template slot="notifyStateSlot" slot-scope="{ record }">
          <a-badge
            :status="record.notifyState === 1 ? 'processing' : 'error'"
            :text="record.notifyState === 1 ? '已发送' : '未发送'"
          />
        </template>
        <template slot="upiSlot" slot-scope="{ record }">
          <div class="order-row">
            <span>{{ record.upi?.length > 0 ? record.upi : '--' }}</span>
          </div>
        </template>
        <template slot="opSlot" slot-scope="{record}">  <!-- 操作列插槽 -->
          <JeepayTableColumns>
            <a-button type="link" v-if="$access('ENT_PAY_ORDER_VIEW')" @click="detailFunc(record.payOrderId)">详情</a-button>
            <!-- <a-button type="link" v-if="$access('ENT_PAY_ORDER_REFUND')" style="color: red" v-show="(record.state === 2 && record.refundState !== 2)" @click="openFunc(record, record.payOrderId)">退款</a-button> -->
          </JeepayTableColumns>
        </template>
      </JeepayTable>

    </a-card>
    <!-- 退款弹出框 -->
    <refund-modal ref="refundModalInfo" :callbackFunc="searchFunc"></refund-modal>
    <!-- 日志详情抽屉 -->
    <template>
      <a-drawer
        width="50%"
        placement="right"
        :closable="true"
        :visible="visible"
        :title="visible === true? '订单详情':''"
        @close="onClose"
      >
        <a-row justify="space-between" type="flex">
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="平台订单ID">
                <a-tag color="purple">
                  {{ detailData.payOrderId }}
                </a-tag>
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="商户ID">
                {{ detailData.mchNo }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="商户订单ID">
                {{ detailData.mchOrderNo }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="商户名称">
                {{ detailData.mchName }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="应用APPID">
                {{ detailData.appId }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="订单状态">
                <a-tag :color="detailData.state === 0?'blue':detailData.state === 1?'orange':detailData.state === 2?'green':detailData.state === 6?'':'volcano'">
                  {{ detailData.state === 0?'订单生成':detailData.state === 1?'支付中':detailData.state === 2?'支付成功':detailData.state === 3?'支付失败':detailData.state === 4?'已撤销':detailData.state === 5?'已退款':detailData.state === 6?'订单关闭':'未知' }}
                </a-tag>
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="支付金额">
                <a-tag color="green">
                  {{ detailData.amount }}
                </a-tag>
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions><a-descriptions-item label="手续费"><a-tag color="pink">{{ detailData.mchFeeAmount }}</a-tag></a-descriptions-item></a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions><a-descriptions-item label="商家费率">{{ '₹' + detailData.mchFeeAmount + '(' + (detailData.mchFeeRate) + '%)' }}</a-descriptions-item></a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="支付错误码">
                {{ detailData.errCode }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="支付错误描述">
                {{ detailData.errMsg }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="订单失效时间">
                {{ formatTime(detailData.expiredTime) }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="支付成功时间">
                {{ formatTime(detailData.successAt) }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="创建时间">
                {{ formatTime(detailData.createdAt) }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="更新时间">
                <!-- 公共方法转化时间，没有，展示-- ，有 展示时间 -->
                {{ formatTime(detailData.updatedAt) }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-divider />
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="商品标题">
                {{ detailData.subject }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="商品描述">
                {{ detailData.body }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="接口代码">
                {{ detailData.ifCode }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="货币代码">
                {{ detailData.currency }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="支付类型">
                {{ detailData.payType }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="支付方式">
                {{ detailData.wayCode }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="客户端IP">
                {{ detailData.clientIp }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="用户标识">
                {{ detailData.channelUser }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="渠道订单ID">
                {{ detailData.channelOrderNo }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="异步通知地址">
                {{ detailData.notifyUrl }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="页面跳转地址">
                {{ detailData.returnUrl }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="退款次数">
                {{ detailData.refundTimes }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions>
              <a-descriptions-item label="退款总额">
                <a-tag color="cyan" v-if="detailData.refundAmount">
                  {{ detailData.refundAmount }}
                </a-tag>
              </a-descriptions-item>
            </a-descriptions>
          </a-col>

          <a-divider />
          <a-col :sm="12">
            <a-descriptions><a-descriptions-item label="订单分账模式">
              <span v-if="detailData.divisionMode == 0">该笔订单不允许分账</span>
              <span v-else-if="detailData.divisionMode == 1">支付成功按配置自动完成分账</span>
              <span v-else-if="detailData.divisionMode == 2">商户手动分账(解冻商户金额)</span>
              <span v-else>未知</span>
            </a-descriptions-item></a-descriptions>
          </a-col>
          <a-col :sm="12">
            <a-descriptions><a-descriptions-item label="最新分账发起时间">{{ formatTime(detailData.divisionLastTime) }}</a-descriptions-item></a-descriptions>
          </a-col>
        </a-row>
        <a-divider />
        <a-row justify="start" type="flex">
          <a-col :sm="24">
            <a-form-model-item label="扩展参数">
              <a-input
                type="textarea"
                disabled="disabled"
                style="height: 100px;color: black"
                v-model="detailData.extParam"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-drawer>
    </template>
    <ExportRecordModal
      :visible="exportRecordVisible"
      :reqTableDataFunc="getOrderExportList"
      @close="exportRecordVisible = false"
    />
  </page-header-wrapper>
</template>
<script>
import JeepayTextUp from '@/components/JeepayTextUp/JeepayTextUp' // 文字上移组件
import JeepayTable from '@/components/JeepayTable/JeepayTable'
import JeepayTableColumns from '@/components/JeepayTable/JeepayTableColumns'
import RefundModal from './RefundModal' // 退款弹出框
import { API_URL_RECEIVE_ORDER_LIST, req, getPayInOrderListCount, getPayInOrderExportList, searchPayInOrderExportList } from '@/api/manage'
import moment from 'moment'
import { getPaymentStatusText, getPaymentStatusColor, PAYMENT_STATUS } from '@/utils/constants'
import { tableColumns } from './tableColumns'
import { formatAmount, formatTime } from '@/utils/util'
import CopyButton from '@/components/CopyButton/index.vue'
import OrderStatistics from '@/components/OrderStatistics/OrderStatistics'
import TimeRangeFilter from '@/components/TimeRangeFilter/TimeRangeFilter'
import ExportRecordModal from '@/components/ExportRecordModal'

export default {
  name: 'IsvListPage',
  components: { JeepayTable, JeepayTableColumns, JeepayTextUp, RefundModal, CopyButton, OrderStatistics, TimeRangeFilter, ExportRecordModal },
  data () {
    return {
      btnLoading: false,
      tableColumns: tableColumns,
      searchData: {},
      createdStart: '', // 选择开始时间
      createdEnd: '', // 选择结束时间
      visible: false,
      detailData: {},
      payWayList: [],
      PAYMENT_STATUS, // 支付状态常量
      // 统计数据
      statisticsData: {},
      statisticsLoading: false,
      exportRecordVisible: false,
      exportLoading: false
    }
  },
  computed: {
  },
  mounted () {
    if (this.$access('ENT_PAY_ORDER_SEARCH_PAY_WAY')) {
      this.initPayWay()
    }
    // 初始化获取统计数据
    this.getStatisticsData()
  },
  methods: {
    getPaymentStatusText,
    getPaymentStatusColor,
    formatAmount,
    formatTime,

    queryFunc () {
      this.btnLoading = true
      this.$refs.infoTable.refTable(true)
      // 同时获取统计数据
      this.getStatisticsData()
    },
    // 请求table接口数据
    reqTableDataFunc: (params) => {
      return req.list(API_URL_RECEIVE_ORDER_LIST, params)
    },
    searchFunc: function () { // 点击【查询】按钮点击事件
      this.$refs.infoTable.refTable(false)
    },
    // 打开退款弹出框
    openFunc (record, recordId) {
      if (record.refundState === 2) {
        return this.$infoBox.modalError('订单无可退款金额', '')
      }
      this.$refs.refundModalInfo.show(recordId)
    },
    detailFunc: function (recordId) {
      const that = this
      req.getById(API_URL_RECEIVE_ORDER_LIST, recordId).then(res => {
        that.detailData = res
      })
      this.visible = true
    },
    moment,
    handleTimeRangeChange (timeRange) {
      // 根据TimeRangeFilter组件返回的格式设置搜索参数
      this.searchData.createdStart = timeRange.startTime
      this.searchData.createdEnd = timeRange.endTime
    },
    onClose () {
      this.visible = false
    },
    // initPayWay: function () {
    //   const that = this
    //   req.list(API_URL_PAYWAYS_LIST, { 'pageSize': -1 }).then(res => { // 支付方式下拉列表
    //     that.payWayList = res.records
    //   })
    // },
    changeStr2ellipsis (orderNo, baseLength) {
      const halfLengh = parseInt(baseLength / 2)
      return orderNo.substring(0, halfLengh - 1) + '...' + orderNo.substring(orderNo.length - halfLengh, orderNo.length)
    },
    handleLoadClose () {
      this.btnLoading = false
      this.refreshLoading = false
    },
    // 获取统计数据
    async getStatisticsData () {
      try {
        this.statisticsLoading = true
        const params = { ...this.searchData }
        const res = await getPayInOrderListCount(params)
        this.statisticsData = res || {}
      } catch (error) {
        console.error('获取统计数据失败:', error)
        this.statisticsData = {}
      } finally {
        this.statisticsLoading = false
      }
    },
    resetForm () {
      // 重置搜索条件
      this.searchData = {}
      // 重置时间范围
      this.$nextTick(() => {
        // 如果TimeRangeFilter组件有引用，则调用其重置方法
        if (this.$refs.timeRangeFilter) {
          this.$refs.timeRangeFilter.resetToDefault()
        }
        this.queryFunc()
      })
    },
    showExportRecords () {
      this.exportRecordVisible = true
    },
    exportFunc () {
      searchPayInOrderExportList(this.searchData).then(res => {
        this.$message.success('导出请求已提交，请在导出记录中查看进度')
        this.exportLoading = false
      }).catch(err => {
        console.error('导出失败:', err)
        this.$message.error('导出失败')
        this.exportLoading = false
      })
    },
    getOrderExportList (params) {
      // JeepayTable会传递分页参数: { page, pageSize, ... }
      return getPayInOrderExportList(params)
    }
  }
}
</script>
<style lang="less" scoped>

///deep/ .ant-table-fixed{
//  tr{
//    th{
//      padding: 0px 0px;
//    }
//  }
//  }

.order-list {
  -webkit-text-size-adjust:none;
  font-size: 12px;
  display: flex;
  flex-direction: column;

  p {
    white-space:nowrap;
    span {
      display: inline-block;
      font-weight: 800;
      height: 16px;
      line-height: 16px;
      width: 35px;
      border-radius: 5px;
      text-align: center;
      margin-right: 2px;
    }
  }
}
</style>
